"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamMemberUpdateSchema = exports.teamMemberCreateSchema = exports.teamMemberSchema = void 0;
const zod_1 = require("zod");
// Full DB row schema — updated to match Prisma TeamMember model fields
exports.teamMemberSchema = zod_1.z.object({
    id: zod_1.z.string().cuid().optional(),
    name: zod_1.z.string().min(1).max(255),
    nameEn: zod_1.z.string().max(255).nullable().optional(),
    role: zod_1.z.string().min(1).max(255),
    roleEn: zod_1.z.string().max(255).nullable().optional(),
    imageUrl: zod_1.z.string().url().or(zod_1.z.literal("")).default(""),
    order: zod_1.z.number().int().default(0),
});
// API verbatim create/update schemas (source of truth: apps/api/src/common/schemas.ts)
exports.teamMemberCreateSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(255),
    nameEn: zod_1.z.string().max(255).nullable().optional(),
    role: zod_1.z.string().min(1).max(255),
    roleEn: zod_1.z.string().max(255).nullable().optional(),
    imageUrl: zod_1.z.string().url().or(zod_1.z.literal("")).default(""),
    order: zod_1.z.number().int().default(0),
});
exports.teamMemberUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().cuid(),
    name: zod_1.z.string().min(1).max(255).optional(),
    nameEn: zod_1.z.string().max(255).nullable().optional(),
    role: zod_1.z.string().min(1).max(255).optional(),
    roleEn: zod_1.z.string().max(255).nullable().optional(),
    imageUrl: zod_1.z.string().url().or(zod_1.z.literal("")).optional(),
    order: zod_1.z.number().int().optional(),
});
//# sourceMappingURL=team-member.js.map